module.exports = __webpack_public_path__ + "static/media/events-manage.069807b0.svg";